import { getCookie, on, setSessionCookie } from "../../utils/dom";

const SITE_MESSAGES_COOKIE = "SiteMessages";
const MAX_DISMISSED_MESSAGE_IDS = 50;

const getDismissedMessageIds = (): Set<string> => {
  const cookieValue = getCookie(SITE_MESSAGES_COOKIE);

  if (!cookieValue) return new Set();

  try {
    const parsedValue: unknown = JSON.parse(cookieValue);

    if (Array.isArray(parsedValue)) {
      return new Set(
        parsedValue.filter(
          (value): value is string => typeof value === "string",
        ),
      );
    }
  } catch {}

  return new Set([cookieValue]);
};

const initialize = (): void => {
  const dismissedMessageIds = getDismissedMessageIds();
  const closeButtons = document.querySelectorAll<HTMLElement>(
    ".js-siteMessage__close",
  );

  closeButtons.forEach((button) => {
    const messageId = button.dataset.messageId;
    const message = button.closest<HTMLElement>(".js-siteMessage");

    if (!message || !messageId) return;

    if (dismissedMessageIds.has(messageId)) {
      message.remove();
      return;
    }

    button.addEventListener("click", () => {
      dismissedMessageIds.add(messageId);
      const recentDismissedMessageIds = Array.from(dismissedMessageIds).slice(
        -MAX_DISMISSED_MESSAGE_IDS,
      );
      setSessionCookie(
        SITE_MESSAGES_COOKIE,
        JSON.stringify(recentDismissedMessageIds),
      );
      message.remove();
    });
  });
};

on(document, "DOMContentLoaded", initialize);
